module.exports = __webpack_public_path__ + "img/gerüstbohle-rahmen.d0ab3e9a.jpg";